//InviewHalf
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?module.exports=e(require("jquery")):e(jQuery)}(function(e){function t(){if(l.length){var t=0,o=e.map(l,function(e){var t=e.data.selector,i=e.$element;return t?i.find(t):i});for(i=i||(v=void 0,p=void 0,g=void 0,(g={height:f.innerHeight,width:f.innerWidth}).height||((v=r.compatMode)||!e.support.boxModel)&&(g={height:(p="CSS1Compat"===v?a:r.body).clientHeight,width:p.clientWidth}),g),n=n||{left:f.pageXOffset||a.scrollLeft||r.body.scrollLeft,top:f.pageYOffset||a.scrollTop||r.body.scrollTop};t<l.length;t++)if(e.contains(a,o[t][0])){var d=e(o[t]),c=d[0].offsetHeight,h=d[0].offsetWidth,s=d.offset(),u=d.data("inview");if(!n||!i)return;s.top-100>n.top-i.height&&s.top+100<n.top+i.height&&s.left+h>n.left&&s.left<n.left+i.width?u||d.data("inview",!0).trigger("inview",[!0]):u&&d.data("inview",!1).trigger("inview",[!1])}}var v,p,g}var i,n,o,l=[],r=document,f=window,a=r.documentElement;e.event.special.inview={add:function(i){l.push({$element:e(this),data:i,element:this}),!o&&l.length&&(o=setInterval(t,250))},remove:function(e){for(var t=0;t<l.length;t++){var i=l[t];if(i.element===this&&i.data.guid===e.guid){l.splice(t,1);break}}l.length||(clearInterval(o),o=null)}},e(f).on("scroll resize scrollstop",function(){i=n=null}),!a.addEventListener&&a.attachEvent&&a.attachEvent("onfocusin",function(){n=null})});


function isTouchDevice() {
  var result = false;
  if (window.ontouchstart === null) {
    result = true;
  }  
  return result;
}
const setVw = function() {
  const vw = document.documentElement.clientWidth / 100;
  const vh = window.innerHeight / 100;
  const lvh = window.outerHeight / 100;
  document.getElementsByTagName('body')[0].style.setProperty('--vw', `${vw}px`);
  document.getElementsByTagName('body')[0].style.setProperty('--vh', `${vh}px`);
  document.getElementsByTagName('body')[0].style.setProperty('--lvh', `${lvh}px`);
}
//Load
$(window).on('load',function(){
  $('body').addClass('isLoaded');
  $('[data-inview]').on('inview',function(){
    $(this).addClass('isShow');
  });
  $('[data-inviewIn]').children('*').on('inview',function(){
    $(this).addClass('isShow');
  });
});
//Func
$(function(){
  //Smooth
  $('a[href^="#"]').on('click',function() {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - $('.header').outerHeight() + parseInt($('.headingBlock').css('marginTop'));
    $('body,html').animate({scrollTop:position}, 800);
    if($(this).closest('.header__menuNavList').length && $('.header__btnLink').hasClass('menuOpen')) {
      menuClose();
    }
    return false;
  });
  //Vw
  setVw();
  //Menu
  function menuClose(){
    $('.header__btnLink').removeClass('menuOpen');
    $('.header__menu').stop().slideUp();
  }
  function menuOpen(){
    $('.header__btnLink').addClass('menuOpen');
    $('.header__menu').stop().slideDown();
  }
  $('.header__btnLink').on('click',function(){
    if($(this).hasClass('menuOpen')) {
      menuClose();
    } else {
      menuOpen();
    }
    return false;
  });
});
//LazySizes
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
window.lazySizesConfig.customMedia = {
  '--sp': '(max-width: 767px)',
  '--pc': '(min-width: 768px)',
  '--full': '(min-width: 1367px)',
  '--portrait': '(orientation: portrait)',
};
//Scroll
var scrollFlag = '';
function scrollSearch(scrollPosition) {
  var showPosition = 50;
  if(scrollPosition < showPosition && scrollFlag != 'min') {
    scrollFlag = 'min';
    $('body').removeClass('isScroll');
  } else if(scrollPosition >= showPosition && scrollFlag != 'over') {
    scrollFlag = 'over';
    $('body').addClass('isScroll');
  }
}
var btnFlag = '';
function btnToggle(scrollPosition) {
  var hidePosition = $('.footer').offset().top - $(window).height();
  if(scrollPosition < hidePosition && btnFlag != 'min') {
    btnFlag = 'min';
    $('.footer__allBtn').stop().fadeIn(200);
  } else if(scrollPosition >= hidePosition && btnFlag != 'over') {
    btnFlag = 'over';
    $('.footer__allBtn').stop().fadeOut(200);
  }
}
$(window).on('load scroll',function(){
  var scrollPosition = $(window).scrollTop();
  scrollSearch(scrollPosition);
  if($('.footer').length) {
    btnToggle(scrollPosition);
  }
});
var winW = $(window).width();
$(window).on('resize',function(){
  if(winW != $(window).width()) {
    setVw();
    winW = $(window).width();
  }
});
/* --------------------------------------------------------------------
Top
-------------------------------------------------------------------- */
if($('.announcement__contents').length) {
  var duration = $('.announcement__contentsWrapItem').outerWidth() / 30;
  var style = '<style type="text/css">.announcement__contentsWrapItem { animation: slider '+duration+'s linear 0s infinite; } @keyframes slider { 0% { transform: translate(0, 0); }  100% { transform: translate(-100%, 0); } }</style>';
  $('head').append(style);
}
/* --------------------------------------------------------------------
Product
-------------------------------------------------------------------- */
$('.product__mediaThumbItem').on('click',function(){
  var index = $(this).prevAll('.product__mediaThumbItem').length;
  $(this).closest('.product__media').find('.product__mediaMainItem').hide().eq(index).fadeIn();
});
$('.closeBtn__link').on('click',function(){
  var ref = document.referrer;
  var hereHost = window.location.hostname;
  var sStr = "^https?://" + hereHost;
  var rExp = new RegExp( sStr, "i" );
  if( ref.length == 0 ) {
    location.href = $(this).attr('href');
  }
  else if( ref.match( rExp ) ) {
    history.back();
  }
  else {
    location.href = $(this).attr('href');
  }
  return false;
});
$('.topStory__contentDescBtnLink').on('click',function(){
  $('.topStory__contentDescBtn').toggleClass('isOpen');
  $('.topStory__contentDescText--toggle').stop().slideToggle();
  if($('.topStory__contentDescBtn').hasClass('isOpen')) {
    $('html,body').animate({scrollTop:$('.topStory__contentDescText--toggle').prev('.topStory__contentDescText').offset().top - $('.header').outerHeight()}, 800);
  }
  return false;
});